import React from 'react'
import './Services.css'

function Services({
    Img1,head1,desc1,
    Img2,head2,desc2,
    Img3,head3,desc3,
}) {
    return (
        <div className="Services" id="services">
            
            <div className="margin--align">
                <h1 className="head--title">What can I Do?</h1>
                <div className="line"></div>
                
                <ServiceCards 
                    ImgSrc={Img1} 
                    Heading={head1}
                    Description={desc1} 
                />
                <ServiceCards 
                    ImgSrc={Img2} 
                    Heading={head2}
                    Description={desc2}
                    ImgStart='reverse' 
                />
                <ServiceCards 
                    ImgSrc={Img3} 
                    Heading={head3}
                    Description={desc3} 
                />

            </div>
        </div>
    )
}

function ServiceCards({ImgSrc, Heading, Description, ImgStart}){
    return(
        <div className={`${ImgStart === 'reverse' ? `service--flex-box service--flex-reverse` : `service--flex-box`}`}>
            <div className="box--img">
                <img src={ImgSrc} alt=""/>
            </div>
            <div className="box--info">
                <h2 className="sec--head-title">    
                    <span>&#9732;</span> {Heading}
                </h2>
                <p className="sec--head-para">
                    {Description}
                </p>
            </div>
        </div>
    )
}

export default Services
